(function () {
  var DEFAULT_FORM_ID = 'T3w7Cq';
  var FR_FORM_ID = 'V3ZPfc';
  var OPEN_FORM_SELECTORS = '.openKlaviyoForm, .open-klaviyo-form, .openKlaviyoForm-fr';

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
      return;
    }

    callback();
  }

  function normalizeText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function removeDisabledState() {
    document.querySelectorAll(OPEN_FORM_SELECTORS).forEach(function (element) {
      element.classList.remove('disabled');
      element.removeAttribute('aria-disabled');
    });
  }

  function openKlaviyoForm(formId) {
    if (!formId) return;

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  }

  function formIdFromTrigger(trigger) {
    var explicitFormId = trigger.getAttribute('data-klaviyo-form-id');
    if (explicitFormId) return explicitFormId;

    if (trigger.classList.contains('openKlaviyoForm-fr') || trigger.classList.contains('link-fr')) {
      return FR_FORM_ID;
    }

    return DEFAULT_FORM_ID;
  }

  function handleOpenFormClick(event) {
    var trigger = event.target && event.target.closest ? event.target.closest(OPEN_FORM_SELECTORS) : null;
    if (!trigger) return;

    event.preventDefault();
    openKlaviyoForm(formIdFromTrigger(trigger));
  }

  function configFromElement(element) {
    var formId = element.getAttribute('data-klaviyo-form-id');
    var productId = element.getAttribute('data-klaviyo-product-id');
    var quantity = parseInt(element.getAttribute('data-klaviyo-product-quantity'), 10);
    var buttonLabel = element.getAttribute('data-klaviyo-button-label');

    if (!formId || !productId || !buttonLabel) return null;

    return {
      formId: formId,
      productId: productId,
      quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1,
      buttonLabel: normalizeText(buttonLabel)
    };
  }

  function legacyConfigs() {
    var mappings = [
      {
        selector: '.klaviyo-formadd_to_cart',
        formId: 'klaviyoformid',
        productId: 'klaviyoproductid',
        quantity: 'klaviyoproductquantity',
        buttonLabel: 'klaviyoaddtocartbuttonlabel'
      },
      {
        selector: '.klaviyo-second_add_to_cart',
        formId: 'klaviyoformidsecond',
        productId: 'klaviyoproductidsecond',
        quantity: 'klaviyoproductquantitysecond',
        buttonLabel: 'klaviyoaddtocartbuttonlabelsecond'
      },
      {
        selector: '.klaviyo-third_add_to_cart',
        formId: 'klaviyoformidthird',
        productId: 'klaviyoproductidthird',
        quantity: 'klaviyoproductquantitythird',
        buttonLabel: 'klaviyoaddtocartbuttonlabelthird'
      },
      {
        selector: '.klaviyo-fourth_add_to_cart',
        formId: 'klaviyoformidfourth',
        productId: 'klaviyoproductidfourth',
        quantity: 'klaviyoproductquantityfourth',
        buttonLabel: 'klaviyoaddtocartbuttonlabelfourth'
      }
    ];

    return mappings.map(function (mapping) {
      var element = document.querySelector(mapping.selector);
      if (!element) return null;

      var quantity = parseInt(element.dataset[mapping.quantity], 10);
      if (!element.dataset[mapping.formId] || !element.dataset[mapping.productId] || !element.dataset[mapping.buttonLabel]) {
        return null;
      }

      return {
        formId: element.dataset[mapping.formId],
        productId: element.dataset[mapping.productId],
        quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1,
        buttonLabel: normalizeText(element.dataset[mapping.buttonLabel])
      };
    }).filter(Boolean);
  }

  function addToCartConfigs() {
    var configs = Array.prototype.map.call(
      document.querySelectorAll('[data-klaviyo-add-to-cart]'),
      configFromElement
    ).filter(Boolean);

    return configs.length ? configs : legacyConfigs();
  }

  function klaviyoFormId(form) {
    if (!form) return null;

    var testId = form.getAttribute('data-testid') || '';
    var match = testId.match(/klaviyo-form-([^"\s]+)/);

    return match ? match[1] : null;
  }

  function configForButton(button) {
    var form = button.closest('.klaviyo-form');
    var formId = klaviyoFormId(form);
    var buttonText = normalizeText(button.textContent || button.value);

    if (!formId || !buttonText) return null;

    return addToCartConfigs().find(function (config) {
      return config.formId === formId && config.buttonLabel === buttonText;
    });
  }

  function refreshCartUi() {
    if (typeof window.refreshCart === 'function') {
      window.refreshCart();
    }

    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  function addProductToCart(config, button) {
    if (button.dataset.klaviyoCartPending === 'true') return;
    button.dataset.klaviyoCartPending = 'true';

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: config.productId,
        quantity: config.quantity
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Klaviyo add to cart failed');
      return response.json();
    }).then(function () {
      refreshCartUi();
    }).catch(function (error) {
      window.console && window.console.error && window.console.error(error);
    }).finally(function () {
      delete button.dataset.klaviyoCartPending;
    });
  }

  function handleKlaviyoCartButton(event) {
    var button = event.target && event.target.closest
      ? event.target.closest('.klaviyo-form button, .klaviyo-form input[type="submit"]')
      : null;

    if (!button) return;

    var config = configForButton(button);
    if (!config) return;

    event.preventDefault();
    addProductToCart(config, button);
  }

  ready(removeDisabledState);
  window.addEventListener('load', removeDisabledState);
  document.addEventListener('click', handleOpenFormClick);
  document.addEventListener('click', handleKlaviyoCartButton, true);
})();
